import BaseController from './BaseController';

import DealListDataSource from '../dataSources/DealListDataSource';
import UserInfoDataSource from '../dataSources/UserInfoDataSource';

class DealListController extends BaseController {
    static get name() {
        return 'DealListController';
    }

    static getInstance(options) {
        return new DealListController(options);
    }

    onActivate() {
        this.bindGluBusEvents({
            DEAL_LISTS_LOAD_REQUEST: this.onDealListsLoadRequest,
            DEAL_LISTS_GET_REQUEST: this.onDealListsGetRequest,
            ACTIVE_DEAL_LIST_GET_REQUEST: this.onGetActiveDealList,
        });

        this.dealListDataSource = this.activateSource(DealListDataSource);
        this.userInfoDataSource = this.activateSource(UserInfoDataSource);
    }

    onDealListsLoadRequest = () => {
        this.dealListDataSource.loadDealLists().then(dealLists => {
            this.bus.emit('DEAL_LISTS_LOAD_SUCCESS', {
                dealLists,
            });
        });
    };

    onDealListsGetRequest = () => {
        this.bus.emit('DEAL_LISTS', {
            dealLists: this.dealListDataSource.dealLists,
        });
    };

    onGetActiveDealList() {
        const { myDealsActiveList } = this.userInfoDataSource.userPreferences;

        const { dealLists } = this.dealListDataSource;
        const dealList =
            (myDealsActiveList && dealLists.find(dl => dl.id === myDealsActiveList.id)) ||
            dealLists[0];

        this.bus.emit('ACTIVE_DEAL_LIST', {
            dealList: dealList || null,
        });
    }

    onDeactivate() {
        this.unbindGluBusEvents();
    }
}

export default DealListController;
